import VueWrapper from '@/components/core/Vue/vue.wrapper';
import {LoaderService} from '@/sdk';
import {LocationApi} from '@/sdk/api-services';
import {Component, Prop} from 'vue-property-decorator';

@Component
export default class AssetManagementWarningsListComponent extends VueWrapper {
    @Prop({
        required: true,
    })
    public siteId!: string;

    public alertsList: any[] = [];

    public mounted(): void {
        this.getAlerts();
    }

    public getAlerts() {
        new LoaderService().showFullScreenLoader('Loading data field rules status.');
        new LocationApi()
            .GetSiteLocationsFormStatus(this.siteId)
            .subscribe(
                res => {
                    this.alertsList = res.Data ?? [];
                    console.log('alertsList', this.alertsList);
                },
                err => {
                    //
                }
            )
            .add(() => {
                new LoaderService().hideFullScreenLoader();
            });
    }
}
